import { Link } from 'react-router-dom';

const programs = [
  {
    title: 'Computer Skills Courses',
    subtitle: 'Digital literacy for the future',
    description: 'Hands-on training in essential computer skills, from basic digital literacy to advanced programming, preparing youth for the modern workforce.',
    icon: 'ri-computer-line',
    href: '/courses',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20computer%20lab%20with%20young%20Malaysian%20students%20learning%20coding%20on%20laptops%2C%20bright%20classroom%20with%20natural%20light%2C%20diverse%20youth%20collaborating%2C%20warm%20and%20inspiring%20atmosphere%2C%20clean%20minimal%20aesthetic%2C%20editorial%20photography&width=700&height=875&seq=program-card-1-2026&orientation=portrait',
  },
  {
    title: 'Mentorship Programs',
    subtitle: 'Guidance that changes lives',
    description: 'One-on-one and group mentorship connecting youth with experienced professionals who provide career guidance, life skills, and personal development support.',
    icon: 'ri-user-heart-line',
    href: '/mentorship',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mentor%20and%20young%20student%20having%20meaningful%20conversation%20in%20modern%20community%20center%2C%20warm%20natural%20lighting%2C%20diverse%20Malaysian%20participants%2C%20genuine%20connection%2C%20inspirational%20setting%2C%20clean%20composition&width=700&height=875&seq=program-card-2-2026&orientation=portrait',
  },
  {
    title: 'Community Outreach',
    subtitle: 'Reaching every corner',
    description: 'Mobile programs and community events that bring resources directly to underserved neighborhoods, ensuring no youth is left behind.',
    icon: 'ri-community-line',
    href: '/outreach',
    imageUrl: 'https://readdy.ai/api/search-image?query=Community%20outreach%20event%20in%20Malaysian%20neighborhood%20with%20volunteers%20distributing%20educational%20materials%2C%20colorful%20banners%2C%20families%20gathering%2C%20warm%20tropical%20sunlight%2C%20joyful%20atmosphere%2C%20documentary%20style%20photography&width=700&height=875&seq=program-card-3-2026&orientation=portrait',
  },
];

export default function ProgramsGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold tracking-wider uppercase text-accent-600 mb-3">
            What We Do
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-tight">
            Our Core Programs
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-3 max-w-xl mx-auto">
            Three pillars that drive our mission to empower the youth of Pulau Pinang
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
          {programs.map((program) => (
            <Link
              key={program.href}
              to={program.href}
              className="group relative rounded-2xl overflow-hidden aspect-[4/5] cursor-pointer"
            >
              {/* Image Background */}
              <img
                src={program.imageUrl}
                alt={program.title}
                title={`${program.title} - INSAN PERWIRA`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-black/10"></div>

              {/* Content */}
              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-primary-500/90 backdrop-blur-sm mb-3 md:mb-4">
                  <i className={`${program.icon} text-lg text-background-50`}></i>
                </div>
                <p className="text-background-50/80 text-xs font-medium tracking-wide uppercase mb-1">
                  {program.subtitle}
                </p>
                <h3 className="font-heading font-bold text-lg md:text-xl text-background-50 mb-2">
                  {program.title}
                </h3>
                <p className="text-background-50/75 text-xs md:text-sm leading-relaxed line-clamp-2">
                  {program.description}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-primary-300 text-sm font-medium group-hover:gap-2.5 transition-all">
                  Learn More
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}